module.exports = __webpack_public_path__ + "cc035265263a75315b76e69f5300c987.MP3";